import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
    <motion.div
        className={className}
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    >
        {children}
    </motion.div>
);

export const Eyebrow = ({ children }) => (
    <span className="inline-flex items-center gap-2 font-mono2 text-xs tracking-[0.25em] uppercase text-cyan-400">
        <span className="h-px w-8 bg-cyan-400/60" />
        {children}
        <span className="h-px w-8 bg-cyan-400/60" />
    </span>
);
